module.exports = __webpack_public_path__ + "static/media/credencial.b8609025.png";